import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let getChildrensInGroup = async (kindegartenId=null, groupId, offset, count) => {
    return request.get(`/api/children_group/get_group_members/${kindegartenId === null? authStore.decodeJwt.userId : kindegartenId}/${groupId}/${offset}/${count}`, true).then(r => {
        return rThen(r)
    })
}